import React from 'react';
import logoColor from '../assets/images/logo/flouri-logo-color.svg';
import logoWhite from '../assets/images/logo/flouri-logo-white.svg';
import logoDark from '../assets/images/logo/flouri-logo-dark.svg';

export type LogoVariant = 'color' | 'white' | 'dark' | 'monochrome';
export type LogoSize = 'sm' | 'md' | 'lg' | 'xl';

interface LogoProps {
  variant?: LogoVariant;
  size?: LogoSize;
  className?: string;
  alt?: string;
}

const sizeMap: Record<LogoSize, string> = {
  sm: 'h-6',
  md: 'h-10',
  lg: 'h-13',
  xl: 'h-19',
};

const logoMap: Record<LogoVariant, string> = {
  color: logoColor,
  white: logoWhite,
  dark: logoDark,
  monochrome: logoDark, // Using dark as fallback for monochrome
};

export const Logo: React.FC<LogoProps> = ({
  variant = 'color',
  size = 'md',
  className = '',
  alt = 'Flouri Logo',
}) => {
  const logoPath = logoMap[variant];

  return (
    <img
      src={logoPath}
      alt={alt}
      className={`${sizeMap[size]} ${className}`}
      aria-label={alt}
    />
  );
};

export default Logo;
